var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('PageTitle',{attrs:{"title":"Questionnaires"}}),(_vm.loaded)?_c('QuestionnaireReviewForm',{attrs:{"is-project":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }